import React from "react";
import CurrentOrdersTable from "./CurrentOrderstable";

const Schedule = ({
  filter,
  filteredOrders,
  newOrderIds,
  handleRowClickCurrent,
  openRowCurrent,
  orderDetails,
  selectedDeliveryPerson,
  getTimeElapsed,
  handlePrintClick,
  handleDirectClick,
  setActionModalOrder,
  setCancelModalOrder,
  reciptDetails,
  KitchenPrint,
  getDiningStatusLabel,
  handleCancel,
  setCashModalOrder,
  updateOrderStatus,
  getNewOrders,
  getOrderHistory,
  startDate,
  endDate,
  getOrderDetails,
  loadingOrders,
  setTakeawayOrder,
}) => {
  return (
    <CurrentOrdersTable
      filter={filter}
      filteredOrders={filteredOrders}
      newOrderIds={newOrderIds}
      handleRowClickCurrent={handleRowClickCurrent}
      openRowCurrent={openRowCurrent}
      orderDetails={orderDetails}
      selectedDeliveryPerson={selectedDeliveryPerson}
      getTimeElapsed={getTimeElapsed}
      handlePrintClick={handlePrintClick}
      handleDirectClick={handleDirectClick}
      setActionModalOrder={setActionModalOrder}
      setCancelModalOrder={setCancelModalOrder}
      reciptDetails={reciptDetails}
      KitchenPrint={KitchenPrint}
      getDiningStatusLabel={getDiningStatusLabel}
      handleCancel={handleCancel}
      setCashModalOrder={setCashModalOrder}
      updateOrderStatus={updateOrderStatus}
      getNewOrders={getNewOrders}
      getOrderHistory={getOrderHistory}
      startDate={startDate}
      endDate={endDate}
      getOrderDetails={getOrderDetails}
      loadingOrders={loadingOrders}
      setTakeawayOrder={setTakeawayOrder}
      forceSchedulePink={true}
    />
  );
};

export default Schedule;